import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PacientePesquisaComponent } from './paciente-pesquisa/paciente-pesquisa.component';
import { BasePesquisaComponent, BotaoFocadoFiltroPesquisaDirective, ConteudoPesquisaDirective, FiltroPesquisaDirective, GridPesquisaDirective, ItemFocadoFiltroPesquisaDirective } from './base-pesquisa/base-pesquisa.component';
import { DialogAllModule } from '@syncfusion/ej2-angular-popups';
import { GridAllModule } from '@syncfusion/ej2-angular-grids';
import { TabAllModule, ToolbarAllModule, ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { ButtonAllModule, CheckBoxAllModule } from '@syncfusion/ej2-angular-buttons';
import { SplitButtonAllModule } from '@syncfusion/ej2-angular-splitbuttons';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { TextBoxAllModule } from '@syncfusion/ej2-angular-inputs';
import { LotacaoAtribuicaoPesquisaComponent } from './lotacao-atribuicao-pesquisa/lotacao-atribuicao-pesquisa.component';
import { ProfissionalPesquisaComponent } from './profissional-pesquisa/profissional-pesquisa.component';
import { EquipamentoProfissionalPesquisaComponent } from './equipamento-profissional-pesquisa/equipamento-profissional-pesquisa.component';
import { ExameNaturezaPesquisaComponent } from './exame-natureza-pesquisa/exame-natureza-pesquisa.component';
import { CargoPesquisaComponent } from './cargo-pesquisa/cargo-pesquisa.component';
import { AgendamentoPesquisaComponent } from './agendamento-pesquisa/agendamento-pesquisa.component';
import { DateRangePickerAllModule } from '@syncfusion/ej2-angular-calendars';
import { ErrorHandlerModule } from '../libs/error-handler/error-handler.module';
import { ExameRecomendadoPesquisaComponent } from './exame-recomendado-pesquisa/exame-recomendado-pesquisa.component';
import { AudiometriaPesquisaComponent } from './audiometria-pesquisa/audiometria-pesquisa.component';
import { ExamePesquisaComponent } from './exame-pesquisa/exame-pesquisa.component';
import { NaturezaLesaoPesquisaComponent } from './natureza-lesao-pesquisa/natureza-lesao-pesquisa.component';
import { FinalizacaoModule } from '../finalizacao/finalizacao.module';
import { AppointmentSearchComponent } from './appointment-search/appointment-search.component';
import { AgendaSearchComponent } from './agenda-search/agenda-search.component';
import { TagModule } from '../tag/tag.module';
import { EspecialidadeSearchComponent } from './especialidade-search/especialidade-search.component';
import { TratamentoEspecificoSearchComponent } from './tratamento-especifico-search/tratamento-especifico-search.component';
import { MotivoAberturaAcompanhamentoSearchComponent } from './motivo-abertura-acompanhamento-search/motivo-abertura-acompanhamento-search.component';
import { MotivoAtualizacaoAcompanhamentoSearchComponent } from './motivo-atualizacao-acompanhamento-search/motivo-atualizacao-acompanhamento-search.component';
import { MotivoEncerramentoAcompanhamentoSearchComponent } from './motivo-encerramento-acompanhamento-search/motivo-encerramento-acompanhamento-search.component';
import { Cid10SearchComponent } from './cid10-search/cid10-search.component';
import { HistoriaModeloPesquisaComponent } from './historia-modelo-pesquisa/historia-modelo-pesquisa.component';



@NgModule({
  declarations: [
    PacientePesquisaComponent,
    BasePesquisaComponent,
    FiltroPesquisaDirective,
    ConteudoPesquisaDirective,
    ItemFocadoFiltroPesquisaDirective,
    BotaoFocadoFiltroPesquisaDirective,
    GridPesquisaDirective,
    LotacaoAtribuicaoPesquisaComponent,
    ProfissionalPesquisaComponent,
    EquipamentoProfissionalPesquisaComponent,
    ExameNaturezaPesquisaComponent,
    CargoPesquisaComponent,
    AgendamentoPesquisaComponent,
    ExameRecomendadoPesquisaComponent,
    AudiometriaPesquisaComponent,
    ExamePesquisaComponent,
    NaturezaLesaoPesquisaComponent,
    AppointmentSearchComponent,
    AgendaSearchComponent,
    EspecialidadeSearchComponent,
    TratamentoEspecificoSearchComponent,
    MotivoAberturaAcompanhamentoSearchComponent,
    MotivoAtualizacaoAcompanhamentoSearchComponent,
    MotivoEncerramentoAcompanhamentoSearchComponent,
    Cid10SearchComponent,
    HistoriaModeloPesquisaComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DialogAllModule,
    ToolbarModule,
    GridAllModule,
    TabAllModule,
    ButtonAllModule,
    ErrorHandlerModule,
    TextBoxAllModule,
    DateRangePickerAllModule,
    CheckBoxAllModule,
    FinalizacaoModule,
    TagModule,
    SplitButtonAllModule
  ],
  exports: [
    PacientePesquisaComponent,
    LotacaoAtribuicaoPesquisaComponent,
    ProfissionalPesquisaComponent,
    EquipamentoProfissionalPesquisaComponent,
    ExameNaturezaPesquisaComponent,
    CargoPesquisaComponent,
    AgendamentoPesquisaComponent,
    ExameRecomendadoPesquisaComponent,
    AudiometriaPesquisaComponent,
    ExamePesquisaComponent,
    NaturezaLesaoPesquisaComponent,
    AppointmentSearchComponent,
    AgendaSearchComponent,
    EspecialidadeSearchComponent,
    TratamentoEspecificoSearchComponent,
    MotivoAberturaAcompanhamentoSearchComponent,
    MotivoAtualizacaoAcompanhamentoSearchComponent,
    MotivoEncerramentoAcompanhamentoSearchComponent,
    Cid10SearchComponent,
    HistoriaModeloPesquisaComponent
  ]
})
export class PesquisaModule { }
